import { format as dateFnsFormat, parse } from "date-fns";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { FaPenNib } from "react-icons/fa6";
import { confirmDialog } from "primereact/confirmdialog";
import { useContext } from "react";
import UiContext from "../../store/ui-context";
import { bg } from "date-fns/locale";

const SignatureButton = (props) => {
  const {
    label,
    title,
    fieldId,
    verifField,
    fieldData,
    fieldDatetime,
    data,
    onConfirm,
    jabatanId,
    jabatanIdRequirement,
    onValidate,
    disabled,
    bgColor,
    color,
    className,
    rounded
  } = props;

  const name = data && data[fieldData] ? data[fieldData].nama : undefined;
  const image = data && data[fieldData] ? data[fieldData].signature : undefined;
  const date =
    data && data[fieldDatetime] ? new Date(data[fieldDatetime]) : undefined;

  const uiContext = useContext(UiContext);

  const handleClickValidToVerify = () => {
    const accept = () => {
      if (onConfirm) onConfirm();
    };

    const reject = () => { };

    confirmDialog({
      message: `Meng-verifikasi sebagai ${label.toUpperCase()}, lanjutkan ?`,
      header: "Konfirmasi Verifikasi",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      acceptLabel: "Konfirmasi",
      rejectLabel: "Tidak",
      accept,
      reject,
    });
  };

  const handleClickInvalidToVerify = () => {
    // uiContext.showVerifAuthDialog({
    //   verifField: verifField,
    //   onConfirm: onConfirm,
    // });
    uiContext.showErrorMsg(
      "Error",
      "Anda tidak berhak untuk verifikasi disini!"
    );
  };

  const handleClickVerify = async () => {
    let isValid = true;

    if (onValidate) {
      isValid = await onValidate();
    }
    if (isValid) {
      if (jabatanIdRequirement.includes(jabatanId)) {
        handleClickValidToVerify();
      } else {
        handleClickInvalidToVerify();
      }
    }
  };

  // check if windows size is lg
  const isLg = window.innerWidth < 1024 ? false : true;

  return (
    <Button
      className={`${color ? color + " border-none" : ""} ${className ?? ""}`}
      disabled={disabled}
      onClick={handleClickVerify}
      rounded={rounded}
    >
      <div className="row-center-center gap-2">
        <FaPenNib size={16} />
        <div className="col-center-center leading-tight">
          <span className="!text-xs">Verifikasi</span>
        </div>
      </div>
    </Button>
  );
};

export default SignatureButton;
